var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Requester } from '@frontend-components/utils/requester';
import AuthenticationModalFeature, { ModalSteps } from '@frontend-components/features/Authentication';
const url = new URL(window.location.href);
const AuthenticationModal = ({ onClose, onCreate }) => (_jsx(AuthenticationModalFeature, { apiUrl: url.origin, onClose: onClose, onSubmitCallback: onCreate, step: ModalSteps.LOGIN, onFetchPartners: getPartners }));
function getPartners() {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield Requester.get('/api/partners?priority=1');
        return response.data;
    });
}
export default AuthenticationModal;
